/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logincheckemail2Inputs */

const en_logincheckemail2 = /** @type {(inputs: Logincheckemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email.`)
};

const pt_logincheckemail2 = /** @type {(inputs: Logincheckemail2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifique o seu email.`)
};

/**
* | output |
* | --- |
* | "Check your email." |
*
* @param {Logincheckemail2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const logincheckemail2 = /** @type {((inputs?: Logincheckemail2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logincheckemail2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logincheckemail2(inputs)
	return pt_logincheckemail2(inputs)
});
export { logincheckemail2 as "loginCheckEmail" }